import { Button, Group, Stack, Text, Title } from "@mantine/core";
import { ContextModalProps } from "@mantine/modals";
import { IconRocket } from "@tabler/icons-react";

export interface UpgradeModalProperties {
  role: string;
  limite: number;
  quantidadeAtual: number;
}

const UpgradeColaboradorLimitModal = ({ context, innerProps, id }: ContextModalProps<UpgradeModalProperties>) => {
  const { role, limite, quantidadeAtual } = innerProps;

  const roleNames: Record<string, string> = {
    ADMIN: "administradores",
    MEMBER: "membros",
    TEAM: "equipe",
    MASTER: "masters",
    COLLABORATOR: "colaboradores"
  };

  const roleName = roleNames[role] || "colaboradores";

  /**
   * Handle close modal
   */
  function handleClose() {
    context.closeModal(id);
  }

  /**
   *
   */
  function handleUpgradeClick() {
    // TODO: Implementar navegação para página de upgrade/planos
    console.log("Navegar para página de upgrade");
    handleClose();
  }

  return (
    <Stack gap="lg">
      <Group align="center" gap="md">
        <IconRocket size={48} color="var(--mantine-color-blue-6)" />
        <Title order={2}>Limite atingido!</Title>
      </Group>

      <Text size="md">
        Você atingiu o limite de <strong>{roleName}</strong> permitidos no seu plano atual.
      </Text>

      <Text size="sm" c="dimmed">
        Total em todas as empresas: <strong>{quantidadeAtual}</strong> de <strong>{limite}</strong> permitidos.
      </Text>

      <Text size="sm" c="orange" fw={500}>
        ⚠️ O limite de colaboradores é compartilhado entre todas as empresas da sua licenciada.
      </Text>

      <Text size="md">
        Para adicionar mais {roleName} e aproveitar todo o potencial da plataforma, faça upgrade do seu plano!
      </Text>

      <Group justify="flex-end" mt="md">
        <Button variant="default" onClick={handleClose}>
          Fechar
        </Button>
        <Button variant="filled" color="blue" leftSection={<IconRocket size={16} />} onClick={handleUpgradeClick}>
          Fazer Upgrade
        </Button>
      </Group>
    </Stack>
  );
};

export default UpgradeColaboradorLimitModal;
